// ActiveAnchorContext.jsx
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

const Ctx = createContext(null);

const normalizeOffset = (o) =>
  typeof o === "function"
    ? +o() || 0
    : typeof o === "number"
    ? o
    : Number.parseInt(o, 10) || 0;

export function ActiveAnchorProvider({ ids, offset = 0, children }) {
  const [activeId, setActiveId] = useState(null);
  const getOffset = useMemo(() => () => normalizeOffset(offset), [offset]);

  useEffect(() => {
    const computeActiveSection = () => {
      const navbarOffset = getOffset();
      const currentScrollY = window.scrollY;

      let activeSectionId = null;
      let topMostPassedTop = -Infinity;

      ids.forEach((sectionId) => {
        const el = document.getElementById(sectionId);
        if (!el) return;
        const sectionTop = el.offsetTop - navbarOffset;
        if (sectionTop <= currentScrollY + 1 && sectionTop > topMostPassedTop) {
          topMostPassedTop = sectionTop;
          activeSectionId = sectionId;
        }
      });

      setActiveId(activeSectionId);
    };

    // simple handler; no rAF throttling
    const handleScrollOrResize = () => computeActiveSection();

    window.addEventListener("scroll", handleScrollOrResize, { passive: true });
    window.addEventListener("resize", handleScrollOrResize);
    computeActiveSection(); // initial

    return () => {
      window.removeEventListener("scroll", handleScrollOrResize);
      window.removeEventListener("resize", handleScrollOrResize);
    };
  }, [ids, getOffset]);

  return (
    <Ctx.Provider value={{ activeId, setActiveId, getOffset }}>
      {children}
    </Ctx.Provider>
  );
}

export const useActiveAnchor = () => useContext(Ctx);
